import React, { useContext, useState } from "react";
import { useFormik } from "formik";
import * as YUP from "yup";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { UserContext } from "../../context/User/Context";
import "./Login.css";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

export default function Login() {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  let { setUserToken, setUserData } = useContext(UserContext);
  let emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

  let validationSchema = YUP.object({
    email: YUP.string()
      .matches(emailRegex, "Email is not matched, Please try again!")
      .required("Email is required"),
    password: YUP.string()
      .min(6, "Password is not matched, Please try again!")
      .required("Password isrequired"),
  });

  let navigate = useNavigate();
  const [error, seterror] = useState(null);
  const [isLodding, setisLodding] = useState(false);

  async function loginSubmit(values) {
    setisLodding(true);
    let { data } = await axios
      .post("https://vehex-production.up.railway.app/user/login", values)
      .catch((err) => {
        setisLodding(false);
        seterror(err.response.data.message);
      });

    if (data.message === "you logged in successfully") {
      if (data.payload.role === "admin") {
        localStorage.setItem("role", data.payload.role);
        localStorage.setItem("userToken", data.token);
        setUserToken(data.token);
        setUserData(data.user);
        navigate("/dashboard");
      } else {
        setisLodding(false);
        localStorage.setItem("userToken", data.token);
        localStorage.setItem("role", data.payload.role);
        setUserToken(data.token);
        setUserData(data.user);
        navigate("/");
      }
    } else {
      toast.error("You must register before login! ");
      setisLodding(false);
    }
  }

  let login = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: loginSubmit,
  });

  return (
    <>
                                        <Helmet>
                      <title>Login </title>
                    </Helmet>
      <div className="w-100 bg-black">
        <div className="image w-100 position-relative">
          <div className="overlay">
            <div className="container">
              <div className="w-50 py-4 submitContent box-shadow p-2 mt-2 position-absolute rounded-3">
                {error ? (
                  <div className="alert alert-danger">{error} try again!</div>
                ) : (
                  ""
                )}

                <h2 className="fw-600 mb-3 heading">Login Now</h2>
                <form onSubmit={login.handleSubmit}>
                  <label htmlFor="email" className="fs-4 second-color mt-3">
                    Email :
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-control fs-5"
                    value={login.values.email}
                    onBlur={login.handleBlur}
                    onChange={login.handleChange}
                  ></input>
                  {login.errors.email && login.touched.email ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {login.errors.email}
                    </div>
                  ) : (
                    ""
                  )}

                  <label htmlFor="password" className="fs-4 second-color mt-3">
                    Password :
                  </label>
                  <div className="input-group">
                    <input
                      type={passwordVisible ? "text" : "password"}
                      id="password"
                      name="password"
                      className="form-control fs-5"
                      value={login.values.password}
                      onBlur={login.handleBlur}
                      onChange={login.handleChange}
                    />
                    <span
                      className="input-group-text"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    >
                      <i
                        className={
                          passwordVisible ? "fas fa-eye" : "fas fa-eye-slash"
                        }
                      ></i>
                    </span>
                  </div>
                  {login.errors.password && login.touched.password ? (
                    <div className="alert alert-danger mt-2 mb-3 p-2">
                      {login.errors.password}
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="d-flex justify-content-between mt-2 flex-question">
                    <div className="light-color fs-6">
                      Don't have an email ?{" "}
                      <Link className="mx-1 second-color fs-6" to={"/register"}>
                        Register Now
                      </Link>
                    </div>
                    <div className="light-color fs-6">
                      {" "}
                      <Link
                        className="mx-1 second-color fs-6"
                        to={"/forgetPassword"}
                      >
                        Forget Password ?
                      </Link>
                    </div>
                  </div>

                  {isLodding ? (
                    <button type="button" className="btn text-white py-3">
                      <RotatingLines
                        strokeColor="#c2272d"
                        strokeWidth="10"
                        animationDuration="1"
                        width="30"
                        visible={true}
                      />
                    </button>
                  ) : (
                    <>
                      <button
                        disabled={!(login.isValid && login.dirty)}
                        type="submit"
                        className="my-3 fw-500 border-2 me-2"
                      >
                        Login
                      </button>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
